import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";

const LINKS = [
  { href: "#servicos", label: "Serviços" },
  { href: "#economia", label: "Economia" },
  { href: "#manifesto", label: "Manifesto" },
  { href: "#atuacao", label: "Atuação" },
  { href: "#contato", label: "Contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-[#1E3A8A]/70 backdrop-blur-md"
      data-testid="main-navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <a href="#topo" className="flex items-center gap-3" data-testid="nav-logo-link">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white p-1 shadow-md">
            <img src="/assets/logo-nova-symbol.png" alt="ResgateCar" className="h-full w-full object-contain" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight">
            Resgate<span className="text-[#A3E635]">Car</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-desktop-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-tech text-[11px] uppercase tracking-[0.22em] text-slate-300 transition-colors duration-200 hover:text-[#A3E635]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://wa.me/5531992284075"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="hidden items-center gap-2 rounded-full bg-[#FF5722] px-5 py-2.5 font-tech text-[11px] font-bold uppercase tracking-[0.15em] text-[#1E3A8A] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#E64A19] hover:shadow-[0_8px_30px_rgba(255,87,34,0.4)] sm:flex"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            className="rounded-md border border-white/10 p-2 text-slate-200 lg:hidden"
            aria-label="Abrir menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden border-t border-white/10 bg-[#1E3A8A]/95 lg:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className="rounded-md px-3 py-3 font-tech text-xs uppercase tracking-[0.22em] text-slate-200 hover:bg-white/5 hover:text-[#A3E635]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="https://wa.me/5531992284075"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-whatsapp-button"
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-[#FF5722] px-5 py-3 font-tech text-xs font-bold uppercase tracking-[0.15em] text-[#1E3A8A]"
              >
                <MessageCircle className="h-4 w-4" />
                Falar no WhatsApp
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
